export default {
    menu: {
        home: '首页',
        news: '新闻资讯',
        product: '产品中心',
        solution: '解决方案',
        cases: '经典案例',
        about: '走进通创联',
        service: '用户服务',
        download: '下载中心'
    },
    home: {
        heroTitle: '执法记录仪',
        heroTitleAccent: '行业开创者',
        heroSubtitle: '从现场记录到可信证据管理',
        latestNews: '最新资讯',
        successfulCases: '经典案例',
        details: '详情'
    },
    news: {
        title: '新闻资讯',
        companyNews: '公司新闻',
        industryNews: '行业动态',
        details: '详情'
    },
    product: {
        title: '产品中心',
        recorder: '执法记录仪',
        workstation: '采集工作站',
        system: '执法记录仪系统',
        cabinet: '智能枪弹柜',
        intercom: '对讲机',
        details: '详情'
    },
    solution: {
        title: '解决方案',
        lawEnforcement: '行业执法解决方案',
        smartCabinet: '智能枪弹柜解决方案',
        details: '详情'
    },
    download: {
        title: '下载中心',
        name: '名称',
        download: '下载',
        clickToDownload: '点击下载'
    },
    service: {
        title: '用户服务',
        afterSalesService: '售后服务',
        serviceSystem: '服务支持体系',
        serviceDesc1: '广东通创联新技术有限公司，凭借多年行业服务经验和以"为用户提供最好的服务"为服务宗旨，向客户提供"诚信、便捷、热情、专业"的售前、售中、售后和技术支持等最为完善整体的系统服务。',
        serviceDesc2: '通创联新技术服务体系由两大部分组成：总部服务机构及区域服务机构。',
        serviceNetwork: '服务网点：通创联在全国共有10000多个服务网点20000多名售后工程师',
        quickResponse: '快速响应："7x24小时"全天候人工接听服务，中心城市24小时内上门服务',
        hotline: '24小时服务热线：4009-123456',
        afterSalesPolicy: '售后政策',
        policeServicePolicy: '警用产品服务政策',
        serviceCommitment: '一、 服务承诺',
        nationalWarranty: '全国联保、终身维护',
        warrantyPolicy: '二、保修政策',
        warrantyDesc: '根据通创联警用产品服务政策的产品特性（特种行业用途）并参照国家"部分产品修理更换退货责任规定"，承诺以下服务责任。',
        exchangePolicy: '三、退换机政策',
        exchangeRule1: '1. 产品一经售出且经客户服务人员鉴定属产品质量故障的，可自购买日起15天内申请换新。',
        exchangeRule2: '2. 由于通创联工作人员未按客户要求配置，配置的型号和客户需求不符合的，可以自购买日起7天之内申请换新；',
        exchangeRule3: '3. 所发生的换货和退货,客户须保证产品外观、线材、包装的完整,若相反通创联有权根据情况收取原材料的成本费用。',
        nonWarrantyScope: '四、保修期限内不属于保修的范围',
        nonWarrantyDesc: '产品在保修期内，属于下列情况之一者，不属免费保修范围，也不提供换货、退货，将实施有偿维修服务：',
        nonWarrantyItem1: '1. 因错误安装、操作或在非产品规定的工作环境下使用造成的故障或损坏；',
        nonWarrantyItem2: '2. 未经通创联授权而对产品进行拆卸、修理、改装而造成的故障、损伤；',
        nonWarrantyItem3: '3. 购买后因自然灾害或其他不可抗力因素而造成的故障损坏；',
        nonWarrantyItem4: '4. 产品标签被毁或日期被涂改的；',
        nonWarrantyItem5: '5. 因客户维护不当而导致的软件病毒感染；',
        nonWarrantyItem6: '6. 由于包装或货运公司原因，我司收到客户维修机就出现物理损坏的。',
        nonWarrantyItem7: '7. 无三包凭证或有效发票的，或三包凭证型号与修理产品型号不符或者涂改的。',
        nonWarrantyItem8: '8. 设备存储数据异常变更或丢失等。',
        warrantyPeriod: '五、保修期限的界定',
        warrantyPeriodRule1: '1、 客户提供有效的保修凭证（订货合同、采购发票）即可享受保修服务，保修期限自凭证交易日起算；如果客户所出示保修凭证日期与产品出厂日期相差超过6个月，以产品出厂日期（从通创联仓库出货日）延后3个月计算保修起始日期；',
        warrantyPeriodRule2: '2、 客户无法提供有效保修凭证时，按产品条码的出厂日期延后3个月作为保修起始日期；',
        outOfWarrantyFee: '六、保修范围外的收费问题',
        outOfWarrantyDesc: '整机超过免费保修期后或不在保修范围内的，维修服务按照以下原则执行：',
        feeRule1: '1. 超出保修范围的产品维修均需收取检测费和元件费（成本价格标准）。',
        feeRule2: '2. 过保修期产品经我司技术部确认损坏太严重或其他原因导致无法维修的，我司将原物退回。如需更换同类产品的其他型号，可按折旧补差原则更换产品。',
        others: '七、其他',
        othersDesc: '本服务政策适用于通创联代理商、直销客户等，如超出本政策以外的服务承诺，以双方签署的合同内容为准，并遵循谁承诺谁兑现的原则。'
    },
    about: {
        title: '走进通创联',
        companyIntro: '公司简介',
        companyHonor: '公司荣誉',
        serviceUsers: '服务用户',
        development: '发展历程',
        honorTitle: '公司荣誉',
        clickToView: '注:点击图片查看大图',
        patentInvention: '发明专利',
        qualityAAA: '质量诚信AAA企业',
        patentNew: '新型专利证书',
        innovationOutstanding: '连续四年获警用装备科技创新杰出企业',
        patentAppearance: '外观专利证书',
        innovationAward: '连续四年获警用装备科技创新大奖',
        highTechEnterprise: '省级高新技术企业',
        topTenBrand: '连续三年获警用装备十大品牌',
        contractCredit: '省级守合同重信用企业',
        committeeUnit: '公安部社会公共安全应用基础标准化技术委员会 委员单位',
        draftUnit2011: 'GA/T 947-2011《单警执法视音频记录仪》主要起草单位',
        draftUnit2015: 'GA/T 947.1-2015《单警执法视音频记录系统》主要起草单位',
        fiveStarService: '五星售后服务认证企业 GB/T 33170《大型活动安全要求》主要起草单位'
    },
    footer: {
        news: '新闻资讯',
        companyNews: '公司新闻',
        industryNews: '行业动态',
        products: '产品中心',
        recorder: '执法记录仪',
        workstation: '采集工作站',
        system: '执法记录仪系统',
        cabinet: '智能枪弹柜',
        solutions: '解决方案',
        industrySolution: '行业执法解决方案',
        cabinetSolution: '智能枪弹柜解决方案',
        about: '走进通创联',
        history: '发展历程',
        culture: '企业文化',
        honors: '资质荣誉',
        partners: '合作伙伴',
        service: '用户服务',
        afterSales: '售后服务',
        policy: '售后政策',
        contact: '联系我们',
        email: '邮箱：tcl@tcl-cctv.com',
        phone: '电话：4009-123456',
        address: '地址：广东省深圳市南山区TCL国际E城G3-307',
        copyright: '版权所有：广东通创联新技术有限公司 粤ICP备09043526号'
    }
}
